import { ColumnStyleWidth } from '../enums';

// Widths do not include padding, border, or margin.
export class ColumnStyleClass {
  public static readonly textColumn = {
    style: {
      width: ColumnStyleWidth.TEXT_COLUMN,
    },
    class: ['c-text-column'],
  };

  public static readonly doubleWidthTextColumn = {
    style: {
      width: ColumnStyleWidth.DOUBLE_WIDTH_TEXT_COLUMN,
    },
    class: ['c-double-width-text-column'],
  };

  public static readonly halfWidthTextColumn = {
    style: {
      width: '50%',
      'min-width': ColumnStyleWidth.TEXT_COLUMN,
    },
    class: ['c-text-column'],
  };

  // Half-width name column with a wider floor for row controls (chevron/checkbox).
  public static readonly halfWidthMenuNameColumnWithControls = {
    style: {
      width: '50%',
      'min-width': ColumnStyleWidth.NAME_WITH_CONTROLS_COLUMN,
    },
    class: ['c-text-column'],
  };

  public static readonly numberColumn = {
    style: {
      width: ColumnStyleWidth.NUMBER_COLUMN,
    },
    class: ['c-number-column'],
  };

  public static readonly priceColumn = {
    style: {
      width: ColumnStyleWidth.PRICE_COLUMN,
      'min-width': ColumnStyleWidth.PRICE_COLUMN,
    },
    class: ['c-price-column'],
  };

  public static readonly fixedContentColumn = {
    style: {
      width: ColumnStyleWidth.FIXED_CONTENT_COLUMN,
    },
    class: ['c-fixed-content-column'],
  };

  public static readonly imageColumn = {
    style: {
      width: ColumnStyleWidth.IMAGE_COLUMN,
      'min-width': ColumnStyleWidth.IMAGE_COLUMN,
    },
    class: ['c-image-column'],
  };

  public static readonly iconColumn = {
    style: { width: ColumnStyleWidth.ICON_COLUMN, 'min-width': ColumnStyleWidth.ICON_COLUMN },
    class: ['c-icon-column'],
  };

  public static readonly statusColumn = {
    style: {
      width: ColumnStyleWidth.STATUS_COLUMN,
      'max-width': ColumnStyleWidth.STATUS_COLUMN,
    },
    class: ['c-status-column'],
  };

  public static readonly menuStatusColumn = {
    style: {
      width: ColumnStyleWidth.MENU_STATUS_COLUMN,
      'min-width': ColumnStyleWidth.MENU_STATUS_COLUMN,
      'max-width': ColumnStyleWidth.MENU_STATUS_COLUMN,
    },
    class: ['c-menu-status-column'],
  };

  // Elastic name column for when only one of NAME/IN_APP_NAME is visible; the sole column always owns the row controls, so it gets the wider floor.
  public static readonly menuNameColumn = {
    style: {
      'min-width': ColumnStyleWidth.NAME_WITH_CONTROLS_COLUMN,
    },
    class: ['c-text-column'],
  };

  public static readonly barcodeColumn = {
    style: {
      width: ColumnStyleWidth.IDENTIFIER_COLUMN,
      'min-width': ColumnStyleWidth.IDENTIFIER_COLUMN,
      'max-width': ColumnStyleWidth.IDENTIFIER_COLUMN,
    },
    class: ['c-text-column'],
  };

  // Same shape as barcodeColumn — split into its own definition if the two ever diverge.
  public static readonly posidColumn = ColumnStyleClass.barcodeColumn;
}
